<template>
    <v-form class="item">
        <check-mark
                v-model="item.is_done"
                :id="noteId"
                :sub-id="item.id"
                action-change-false="changeListStatusNew"
                action-change-true="changeListStatusDone"
                :disabled="item.id === null"
                :loading="loading"
        ></check-mark>
        <textarea-autosize
                v-model="item.name"
                @input="save()"
                class="item__input"
                :min-height="30"
                rows="1"
                ref="myTextarea"
                :max-len="255"
                @enter="enter"
        ></textarea-autosize>
        <v-btn
            fab
            small
            color="primary"
            @click="remove()"
            class="btn-close"
            :loading="removeLoading"
            :disabled="removeLoading"
            style="width: 20px !important; height: 20px !important;"
            elevation="0"
        >
            <v-icon
                style="width: 20px; height: 20px; font-size: 14px !important;"
            >mdi-close</v-icon>
        </v-btn>
        <v-icon
                class="ml-2 drag"
                :class="{'drag_disabled': dragDisabled}"
        >mdi mdi-drag</v-icon>
    </v-form>
</template>

<script>
    import CheckMark from '../../../ui/CheckMark';
    import TextareaAutosize from "../../../ui/TextareaAutosize";

    export default {
        components: {CheckMark, TextareaAutosize},
        props: {
            noteId: Number,
            index: Number,
            item: Object,
            dragDisabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                removeLoading: false,
                delay: (function(){
                    let timer = 0;
                    return function(callback, ms){
                        clearTimeout(timer);
                        timer = setTimeout(callback, ms);
                    };
                })(),
                loading: false,
            }
        },
        methods: {
            enter() {
              this.delay(() => this.submit(() => this.$emit('add-next')), 0);
            },
            submit(afterThen) {
                this.$validator.validateAll()
                    .then(res => {
                        if (res) {
                            this.loading = true;

                            const action = this.item.id === null ? 'createList' : 'editList';

                            this.$store.dispatch(action, {
                                data: this.item,
                                id: this.noteId,
                                subId: this.item.id,
                                formErrors: this.errors
                            })
                                .then(res => {
                                    if (this.item.id === null) {
                                      this.item.id = res.id;
                                      this.item.sequence = res.sequence;
                                    }

                                    if (typeof afterThen === 'function') {
                                      afterThen();
                                    }
                                })
                                .finally(() => this.loading = false);
                        }
                    });
            },
            save() {
                this.delay(() => this.submit(), 1000);
            },
            remove() {
                if (this.item.id === null) {
                    this.$emit('removed', this.index);
                } else {
                    this.removeLoading = true;
                    this.$store.dispatch('deleteList', {id: this.noteId, subId: this.item.id})
                        .then(() => {
                            this.$emit('removed', this.index)
                        })
                        .finally(() => this.removeLoading = false);
                }
            },
            focus() {
                this.$refs.myTextarea.$el.focus();
            },
        },
        mounted() {
          if (this.item.id === null) {
            this.$refs.myTextarea.$el.focus();
          }
        }
    }
</script>

<style lang="scss" scoped>
    .item {
        width: 100%;
        display: inline-flex;
        align-items: center;
        border-top: 1px solid rgba(0, 0, 0, 0);
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        padding: 2px 0;

        &:hover {
            border-top-color: #e0e0e0;
            border-bottom-color: #e0e0e0;
        }
        .item__input {
            margin: 0 10px;
            color: rgba(0, 0, 0, 0.87);
            padding: 5px;
            flex-grow: 1;
        }
    }
</style>